export default __webpack_public_path__ + "static/media/testSeries.8af65f14.svg";